// extracted by extract-css-chunks-webpack-plugin
module.exports = {"reminders":"_1IIzUZ","list":"_3ad1_U"};